export default __webpack_public_path__ + "media/images/19-4c76b345a550d3d34739a19a52a5f03f.jpg";